import { Toaster as Sonner, toast } from "sonner";

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#1a1a1a] group-[.toaster]:text-white group-[.toaster]:border-[#333] group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-[#B0B0B0]",
          actionButton:
            "group-[.toast]:bg-[#FF6B35] group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-[#333] group-[.toast]:text-[#B0B0B0]",
          success: "group-[.toaster]:bg-green-500/10 group-[.toaster]:border-green-500/30 group-[.toaster]:text-green-400",
          error: "group-[.toaster]:bg-red-500/10 group-[.toaster]:border-red-500/30 group-[.toaster]:text-red-400",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
